import { render, staticRenderFns } from "./RadioElements.vue?vue&type=template&id=560e6dba&scoped=true"
import script from "./RadioElements.vue?vue&type=script&lang=js"
export * from "./RadioElements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560e6dba",
  null
  
)

export default component.exports